export const OPEN_CONSENT_SETTINGS_EVENT = 'open-consent-settings'

export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_CONSENT_SETTINGS_EVENT))
}
